// extracted by mini-css-extract-plugin
export default {"wrapper":"auth-forms_wrapper__XGpl6","form":"auth-forms_form__ynuKY","actionList":"auth-forms_actionList__jHvwU","action":"auth-forms_action__fOSje","link":"auth-forms_link__WAn-P"};